import { ApiClient } from "./ApiClient";
import qs from "qs";

const caseFollowsPath = "/api/v2/case_follows";

function getAll({
  sort,
  offset,
  limit,
  filter,
  include,
  page,
  size,
}: {
  sort?: string;
  offset?: number;
  limit?: number;
  page?: number;
  size?: number;
  include?: string[];
  filter?: { [key: string]: string | undefined };
} = {}) {
  const params = qs.stringify(
    {
      sort,
      include,
      page: {
        offset,
        limit,
        page,
        size,
      },
      filter,
    },
    { arrayFormat: "comma" },
  );
  return ApiClient().get(`${caseFollowsPath}?${params}`);
}

const create = (
  payload: {
    userId?: string;
    caseId: string;
    email?: string;
    state?: string;
    receivesNefs?: boolean;
    receivesDocketUpdates?: boolean;
    receivedNefFromCourt?: boolean;
  },
  options?: {
    include: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().post(`${caseFollowsPath}?${params}`, {
    data: {
      type: "case_follows",
      attributes: payload,
    },
  });
};

const remove = (caseFollowId: string) =>
  ApiClient().patch(`${caseFollowsPath}/${caseFollowId}`, {
    data: {
      type: "caseFollows",
      id: caseFollowId,
      attributes: { state: "stopped" },
    },
  });

const edit = (
  caseFollowId: string,
  attributes: {
    receivesNefs?: boolean;
    receivesDocketUpdates?: boolean;
    receivedNefFromCourt?: boolean;
    state?: string;
    email?: string;
  },
  options?: {
    include: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().patch(`${caseFollowsPath}/${caseFollowId}?${params}`, {
    data: {
      type: "caseFollows",
      id: caseFollowId,
      attributes,
    },
  });
};

export default { getAll, create, remove, edit };
